<template>
  <div class="rule-configs">
    <div
      v-for="field in item.AvailableFieldList"
      :key="field.FieldId"
      :class="field.ClassNames"
      class="rule-configs-wrapper"
    >
      <configField
        :id="id"
        :category="category"
        :field="getFieldData(field.FieldId)"
        :value="getConfigValue(field.FieldId)"
        :parentField="parentField"
        emitSetConfig
        :class="`rule-configs-${getType(field.FieldId)}`"
        @setConfigValue="setConfigValue"
      />
    </div>
  </div>
</template>
  
  <script>
import { mapGetters } from "vuex";

import getFieldData from "@/util/getFieldData";

export default {
  name: "RuleConfigs",
  components: { configField: () => import("@/components/config-field") },
  props: {
    category: {
      type: String,
    },
    id: {
      type: String,
    },
    item: {
      type: Object,
    },
    parentField: {
      type: String,
    },
  },
  computed: {
    fieldList() {
      const fieldData =
        this.configTemplate && this.configTemplate[this.category];
      return fieldData && fieldData.AvailableFieldList;
    },
    ...mapGetters({
      mergedConfig: "getMergedConfig",
      updatedConfig: "getUpdatedConfigValues",
      configTemplate: "getConfigTemplate",
    }),
  },
  methods: {
    getConfigValue(id) {
      // Needing to set the default value if it's not already set in the config
      const fieldData = this.getFieldData(id);
      const defaultValue = fieldData.DefaultValue;

      if (defaultValue) {
        const existingUpdatedValue =
          this.updatedConfig[this.id] &&
          this.updatedConfig[this.id][this.category] &&
          this.updatedConfig[this.id][this.category][this.parentField] &&
          this.updatedConfig[this.id][this.category][this.parentField][
            this.item.FieldId
          ] &&
          this.updatedConfig[this.id][this.category][this.parentField][
            this.item.FieldId
          ][id];

        if (!existingUpdatedValue) {
          // automatically set the default as the value if there is
          // no other value already set
          this.setConfigValue({
            value: { [id]: defaultValue },
          });
        }
      }

      return (
        this.mergedConfig[this.id] &&
        this.mergedConfig[this.id][this.category] &&
        this.mergedConfig[this.id][this.category][this.parentField] &&
        this.mergedConfig[this.id][this.category][this.parentField][
          this.item.FieldId
        ] &&
        this.mergedConfig[this.id][this.category][this.parentField][
          this.item.FieldId
        ][id]
      );
    },
    getFieldData(id) {
      const fieldData = getFieldData(this.fieldList, id);
      // override the depth for these rule configs
      fieldData.depth = 0;
      return fieldData;
    },
    setConfigValue({ value }) {
      this.$emit("setConfigValue", value);
    },
    getType(id) {
      const data = this.getFieldData(id);
      return data ? data.Type : null;
    },
  },
};
</script>
  
<style lang="scss" scoped>
.rule-configs {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: $qvo-spacing-8;
  &::v-deep {
    div.config-field {
      margin-bottom: 0;
    }
  }
}

.rule-configs {
  div.fullWidth {
    width: 100%;
  }
  .rule-configs-wrapper:has(.rule-configs-checkbox) {
    flex-basis: 100%;
  }
}
</style>